<div class="outlet-wrapper" [class]='selectedTheme'>
    <router-outlet></router-outlet>
</div>
<proofreader-overlay></proofreader-overlay>